import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Carousel } from 'react-bootstrap';
import './testimonial.css';

// Import your existing images
import img from '../../assets/images/OCHA3-1-2-1.png';
import img2 from '../../assets/images/Japan-Times2.png';
import img3 from '../../assets/images//Screenshot_222.png';
import img4 from '../../assets/images/Browns.png';
import img5 from '../../assets/images/Peradeniya-Uni.png';
import img6 from '../../assets/images/02.png';
import img7 from '../../assets/images/5fdf537f587f1e106223e4ab_OCHA3-1-4.png';
import img8 from '../../assets/images/5fdf56df10110f4941e96f8a_OCHA3-1-14.png';
import img9 from '../../assets/images/uva.png';
import img10 from '../../assets/images/d82f2bd6-4bf4-4a08-bd8e-3fb64725082a.png';
import img11 from '../../assets/images/claire-lopez.png';

const Testimonial = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  // Your testimonials data - replace with actual data
  const testimonials = [
    {
      id: 1,
      text: "Gammadda became a social movement that touched the hearts of the rural and strengthened the rural community, not just seeking justice from the state alone. It will be a huge step towards a better village. This initiative has transformed countless lives and continues to make a significant impact in communities across the region, bringing hope and sustainable development to areas that needed it most.",
      name: "Prof. Tilak Wijethunga Bandara",
      position: "University of Peradeniya",
      image: null
    },
    {
      id: 2,
      text: "At MAS we have an extended idea of 'employee' which includes their families and communities. We found a good fit with Gammadda, because it went to the very heart of the village. Together we were able to create far greater positive social impact. The collaboration has been extraordinary and has exceeded all our expectations in terms of community development and sustainable growth.",
      name: "Mr Suren Fernando",
      position: "Group CEO MAS Holdings",
      image: null
    },
    {
      id: 3,
      text: "My name is Claire Lopez, and this fall I’ll be entering my senior year at Brown University, where I’m pursuing degrees in Environmental Science and Visual Art. My studies revolve around the ways that people are impacted by environmental injustices, from land sovereignty to public health to agriculture, and finding community-based solutions to the problems faced primarily by impoverished communities all over the world. I am so grateful for the special opportunity to work with Gammadda this summer and be a part of doing humanitarian work for rural villages across Sri Lanka. It’s important to me that this organization is rooted in mutual care and community and works to implement on-the-ground solutions, which help to foster more beneficial relationships between people and their environment while strengthening the connections amongst Sri Lankan communities, rural and urban alike.",
      name: "Claire Lopez",
      position: "",
      image: img11
    },
    // {
    //   id: 4,
    //   text: "Working with Gammadda has been one of the most rewarding experiences of my career. Their commitment to sustainable development and community empowerment is unmatched. The impact they've made in rural communities is truly inspiring and sets a benchmark for development work.",
    //   name: "John Smith",
    //   position: "International Development Consultant",
    //   image: "https://via.placeholder.com/300x200"
    // }
  ];

  // Organization logos using your imported images
  const organizations = [
    { id: 1, name: "OCHA", logo: img },
    { id: 2, name: "Japan Times", logo: img2 },
    { id: 3, name: "Organization 3", logo: img3 },
    { id: 4, name: "Browns", logo: img4 },
    { id: 5, name: "University of Peradeniya", logo: img5 },
    { id: 6, name: "Organization 6", logo: img6 },
    { id: 7, name: "OCHA 2", logo: img7 },
    { id: 8, name: "OCHA 3", logo: img8 },
    { id: 9, name: "UVA", logo: img9 },
    { id: 10, name: "Organization 10", logo: img10 }
  ];

  const truncateText = (text, maxLength = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleShowModal = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTestimonial(null);
  };

  return (
    <>
      <section className="testimonial-section bg-light py-5">
        {/* Organizations Section */}
        <Container className="mb-5">
          <div className="text-center mb-5">
            <h2 className="gm---heading-2">Recognized by</h2>
            <p className="lead">Gammadda is trusted and endorsed by the following organizations</p>
          </div>
          
          {/* Organization Logos Carousel */}
          <div className="logo-scroll-container">
            <div className="logo-scroll">
              {[...organizations, ...organizations].map((org, index) => (
                <div key={`${org.id}-${index}`} className="logo-item">
                  <img
                    src={org.logo}
                    alt={org.name}
                    className="log-img"
                  />
                </div>
              ))}
            </div>
          </div>
          
          <div className="divider grey mt-4"></div>
        </Container>

        {/* Testimonials Section */}
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3 gm---heading-2 " sy>What People Say About Us</h2>
            {/* <div className="testimonial-divider mx-auto"></div> */}
          </div>

          {/* Bootstrap Carousel for Testimonials */}
          <Carousel 
            indicators={true} 
            controls={true} 
            interval={null}
            className="testimonial-carousel"
          >
            {testimonials.map((testimonial, index) => (
              <Carousel.Item key={testimonial.id}>
                <Container>
                  <Row className="justify-content-center">
                    <Col lg={10} xl={8}>
                      <Card className="testimonial-card border-0 shadow-lg">
                        <Card.Body className="p-0 p-md-5">
                          <div className="d-flex align-items-start">
                            <div className="quote-icon me-3">
                              <span>&ldquo;</span>
                            </div>
                            <div className="flex-grow-1">
                              <blockquote className="blockquote mb-4">
                                <p className="quote-text fs-5">
                                  {truncateText(testimonial.text)}
                                </p>
                              </blockquote>
                              
                              {testimonial.text.length > 150 && (
                                <Button
                                  variant="link"
                                  className="read-more-btn p-0 mb-3"
                                  onClick={() => handleShowModal(testimonial)}
                                >
                                  Read More →
                                </Button>
                              )}
                              
                              <div className="d-flex align-items-center justify-content-between">
                                <div>
                                  <h5 className="quote-person-name mb-1">
                                    {testimonial.name}
                                  </h5>
                                  <p className="text-muted mb-0">
                                    {testimonial.position}
                                  </p>
                                </div>
                                {testimonial.image && (
                                  <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="testimonial-avatar rounded-circle"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </Carousel.Item>
            ))}
          </Carousel>

          {/* Static testimonials  */}
          {/* <div className="mt-5">
            <Container>
              <Row>
                <Col md={6} className="mb-4">
                  <blockquote className="blockquote">
                    <p className="quote-text">
                      " Gammadda became a social movement that touched the hearts of the rural and
                      strengthened the rural community, not just seeking justice from the state alone. It will be a huge step
                      towards a better village. "
                    </p>
                    <footer className="quote-person-name">
                      Prof. Tilak Wijethunga Bandara | University of Peradeniya
                    </footer>
                  </blockquote>
                </Col>
                <Col md={6}>
                  <blockquote className="blockquote">
                    <p className="quote-text">
                      " At MAS we have an extended idea of 'employee' which includes their families and
                      communities. We found a good fit with Gammadda, because it went to the very heart of the village. Together
                      we were able to create far greater positive social impact"
                    </p>
                    <footer className="quote-person-name">
                      Mr Suren Fernando | Group CEO MAS Holdings
                    </footer>
                  </blockquote>
                </Col>
              </Row>
            </Container>
          </div> */}
        </Container>
      </section>

      {/* Modal for Full Testimonial */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal} 
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Full Testimonial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTestimonial && (
            <div>
              {selectedTestimonial.image && (
                <div className="text-center mb-4">
                  <img
                    src={selectedTestimonial.image}
                    alt={selectedTestimonial.name}
                    className="img-fluid rounded shadow"
                    style={{ maxWidth: '200px' }}
                  />
                </div>
              )}
              
              <div className="d-flex align-items-start">
                <div className="quote-icon me-3">
                  <span>&ldquo;</span>
                </div>
                <div className="flex-grow-1">
                  <blockquote className="blockquote mb-4">
                    <p className="fs-5 fst-italic text-muted">
                      {selectedTestimonial.text}
                    </p>
                  </blockquote>
                  <div className="border-top pt-3">
                    <h5 className="text-primary fw-bold mb-1">
                      {selectedTestimonial.name}
                    </h5>
                    <p className="text-muted mb-0 fs-6">
                      {selectedTestimonial.position}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Testimonial;